import { useEffect } from 'react';

import { useBrandContext } from '../contexts/BrandContext';

const useTitle = (title: string): void => {
  const brandContext = useBrandContext();

  const appName = brandContext.brand.appName;

  useEffect(() => {
    document.title = `${appName} | ${title}`;
    return () => {
      document.title = appName;
    };
  }, [title, appName]);
};

export const useTitleBasic = (title: string): void => {
  useEffect(() => {
    document.title = `${title}`;
    return () => {
      document.title = 'Portal';
    };
  }, [title]);
};

export const useAppTitle = (title: string): void => {
  const brandContext = useBrandContext();

  const appName = brandContext.brand.brandName;

  useEffect(() => {
    document.title = `${appName} | ${title}`;
    return () => {
      document.title = appName;
    };
  }, [title, appName]);
};

export default useTitle;
